// import DigitalMarketing from "../src/assets/img/courses/curriculum/Digital Marketing.pdf";

// import { false } from "sass";

const allCourses = [
  //ui/ux
  {
    title: "UI|UX (Product) design",
    duration: "3 Months",
    route: "/ui-design",
    image: "UI-UX.jpeg",
    courseOutline: [
      { id: "1", module: "Introduction to Notion" },
      { id: "2", module: "Basic principles of Design" },
      { id: "3", module: "Introduction to figma" },
      { id: "4", module: "Empathy in Design" },
      { id: "5", module: "Interpreting a Project Brief" },
      { id: "6", module: "Initiation of Case Study" },
      { id: "7", module: "Designing a User flow/User Journey" },
      { id: "8", module: "Designing Wireframe" },
      { id: "9", module: "Design System" },
      { id: "10", module: "Style Guild" },
      { id: "11", module: "Colors" },
      { id: "12", module: "Typography" },
      { id: "13", module: "Iconography" },
      { id: "14", module: "Grid System" },
      { id: "15", module: "Spacing" },
      { id: "16", module: "Text fields" },
      { id: "17", module: "Rapid Testing in Design" },
      { id: "18", module: "Auto Layout & Responsiveness" },
      { id: "19", module: "Fundamentals of UX" },
    ],
    price: 480000, //400000
    showDiscount: false,
    info: {
      title: "UI/UX Designer",
      subTitle: "",
    },
    tools: [
      "notion-logo.png",
      "figma-logo.png",
      "adobeXD-logo.png",
      "google-logo.png",
      "purple-logo.png",
      "Illustrator-logo.png",
      "yellow-logo.png",
      "baloon-logo.png",
    ],
  },

  //full-stack
  {
    title: "Full Stack Software Development",
    duration: "8 Months",
    image: "software-Engineering.jpeg",
    courseOutline: [
      { id: "1", module: "Web Development with HTML & CSS" },
      { id: "2", module: "Advanced HTML & CSS" },
      { id: "3", module: "Flexbox, Grid, & Bootstrap" },
      { id: "4", module: "JavaScript for Front-End" },
      { id: "5", module: "Web Developer Tools: Git & Coding Tips" },
      { id: "6", module: "JavaScript Programming Fundamentals" },
      { id: "7", module: "React Development" },
      { id: "8", module: "JavaScript Development with Node.js" },
      { id: "9", module: "JavaScript Development with Express.js" },
      { id: "10", module: "CI/CD and Deployment of apps to servers" },
      { id: "11", module: "NoSQL Databases with MongoDB" },
      { id: "12", module: "Web Development Industry & Portfolio" },
      { id: "13", module: "Advance Node js for Backend Development" },
      { id: "14", module: "Laravel for Backend Development" },
      { id: "15", module: "Python for  Web Development with Django" },
    ],
    price: 720000,
    showDiscount: false,
    info: {
      title: "Full-Stack Software Engineer",
      subTitle: "",
    },
    tools: [],
  },

  //data sciece
  {
    title: "Data Science & Machine Learning",
    duration: "6 Months",
    image: "dat- science.jpeg",
    courseOutline: [
      { id: "1", module: "Module 1 : Preparatory Sessions – Python & Linux" },
      { id: "2", module: "Module 2 : GIT" },
      {
        id: "3",
        module: "Module 3 : Python with Data Science/ Jupyter Notebook",
      },
      { id: "4", module: "Module 4 : Advanced Statistics" },
      {
        id: "5",
        module: "Module 5 : Machine Learning & Prediction Algorithms",
      },
      { id: "6", module: "Module 6 : Data Science at Scale with PySpark" },
      { id: "7", module: "Module 7 : AI & Deep Learning using TensorFlow" },
      {
        id: "8",
        module: "Module 8 : Deploying Machine Learning Models on Cloud (MLOps)",
      },
      { id: "9", module: "Module 9 : Data Visualization with Tableau" },
      { id: "10", module: "Module 10 : Data Science Capstone Project" },
      {
        id: "11",
        module:
          "Module 11 : Data Analysis with MS Excel, Power BI, SPSS and SQL",
      },
      { id: "12", module: "Module 12 : Data Wrangling with SQL" },
      {
        id: "13",
        module: "Module 13 : Natural Language Processing and its Applications",
      },
      {
        id: "14",
        module: "Module 13 : Natural Language Processing and its Applications",
      },
    ],
    price: 600000,
    curriculumFile: "/curriculum/Data Science.jpg",
    showDiscount: false,
    info: {
      title: "Data Scientist",
      subTitle: "",
    },
    tools: [],
  },

  // {
  //   title: "Data Science",
  //   duration: "6 Months",
  //   image: "dat- science.jpeg",

  //   courseOutline: [
  //     {
  //       id: "1",
  //       module: "Module 1: Preparatory Sessions – Python & Linux",
  //     },
  //     {
  //       id: "2",
  //       module: "Module 2: Git & Version Control",
  //     },
  //     {
  //       id: "3",
  //       module: "Module 3: Python for Data Science & Jupyter Notebook",
  //     },
  //     {
  //       id: "4",
  //       module: "Module 4: Data Analysis & Advanced Statistics",
  //     },
  //     {
  //       id: "5",
  //       module: "Module 5: Data Wrangling & Exploratory Data Analysis",
  //     },
  //     {
  //       id: "6",
  //       module: "Module 6: SQL & Database Management",
  //     },
  //     {
  //       id: "7",
  //       module: "Module 7: Data Visualization with Tableau & Power BI",
  //     },
  //     {
  //       id: "8",
  //       module: "Module 8: Data Analysis with Excel & SPSS",
  //     },
  //     {
  //       id: "9",
  //       module: "Module 9: Machine Learning & Prediction Algorithms",
  //     },
  //     {
  //       id: "10",
  //       module: "Module 10: Data Science at Scale with PySpark",
  //     },
  //     {
  //       id: "11",
  //       module: "Module 11: Natural Language Processing & Applications",
  //     },
  //     {
  //       id: "12",
  //       module: "Module 12: Data Science Capstone Project",
  //     },
  //   ],

  //   price: 600000,

  //   curriculumFile: "/curriculum/Data Science.jpg",

  //   showDiscount: false,

  //   info: {
  //     title: "Data Scientist",
  //     subTitle:
  //       "Learn how to transform raw data into meaningful insights, visualizations, and predictive solutions.",
  //   },

  //   tools: [
  //     "Python",
  //     "Jupyter Notebook",
  //     "Pandas",
  //     "NumPy",
  //     "SQL",
  //     "Excel",
  //     "Power BI",
  //     "Tableau",
  //     "SPSS",
  //     "PySpark",
  //     "Scikit-learn",
  //     "Git",
  //   ],
  // },

  {
    title: "AI Engineering",
    route: "/ai-machine-learning",
    duration: "6 Months",
    image: "dat- science.jpeg",

    courseOutline: [
      {
        id: "1",
        module: "Module 1: Python Programming for AI & Machine Learning",
      },
      {
        id: "2",
        module: "Module 2: Git, Linux & Development Environment",
      },
      {
        id: "3",
        module: "Module 3: Mathematics & Statistics for Machine Learning",
      },
      {
        id: "4",
        module: "Module 4: Data Preparation & Feature Engineering",
      },
      {
        id: "5",
        module: "Module 5: Supervised & Unsupervised Machine Learning",
      },
      {
        id: "6",
        module: "Module 6: Advanced Machine Learning & Model Optimization",
      },
      {
        id: "7",
        module: "Module 7: Deep Learning with TensorFlow & PyTorch",
      },
      {
        id: "8",
        module: "Module 8: Computer Vision & Image Processing",
      },
      {
        id: "9",
        module: "Module 9: Natural Language Processing",
      },
      {
        id: "10",
        module: "Module 10: Generative AI, LLMs & Prompt Engineering",
      },
      {
        id: "11",
        module: "Module 11: AI Applications, APIs & Model Integration",
      },
      {
        id: "12",
        module: "Module 12: Model Deployment & MLOps",
      },
      {
        id: "13",
        module: "Module 13: AI/ML Capstone Project",
      },
    ],

    price: 600000,

    curriculumFile: "/curriculum/AI Machine Learning.jpg",

    showDiscount: false,

    info: {
      title: "AI & Machine Learning Engineer",
      subTitle:
        "Learn to build, train, evaluate, and deploy intelligent systems using modern AI and machine learning technologies.",
    },

    tools: [
      "Python",
      "Jupyter Notebook",
      "NumPy",
      "Pandas",
      "Scikit-learn",
      "TensorFlow",
      "PyTorch",
      "OpenAI",
      "Hugging Face",
      "FastAPI",
      "Docker",
      "Git",
    ],
  },
  //marketng
  {
    title: "Digital Marketing",
    duration: "3 Months",
    image: "digital-marketing.jpeg",
    courseOutline: [
      { id: "", module: " Introduction to Digital Marketing" },
      { id: "", module: "Digital Marketing Strategy" },
      { id: "", module: "Social Media Marketing (SMM) " },
      { id: "", module: "Website Optimization" },
      { id: "", module: "Content Marketing" },
      { id: "", module: "Email Marketing" },
      { id: "", module: "Search Engine Optimization (SEO)" },
      { id: "", module: "Paid Advertising (PPC)" },
      { id: "", module: "Analytics and Reporting" },
      { id: "", module: "Video Marketing" },
      { id: "", module: "E-commerce Marketing" },
      { id: "", module: "E-commerce & Digital Sales Marketing" },
      { id: "", module: "Essential Soft Skills for Digital Marketers" },
    ],
    price: 360000,
    showDiscount: false,
    info: {
      title: "Digital Marketer",
      subTitle: "",
    },
    tools: [],
    curriculumFile: "/curriculum/digital-marketing.pdf",
  },

  //accounting-software
  {
    title: "Accounting Software",
    duration: "3 Months",
    image: "account2.jpeg",
    courseOutline: [],
    price: 300000,
    showDiscount: false,
    info: {
      title: "Digital Accountant",
      subTitle: "",
    },
    curriculumFile: "/curriculum/ACCOUNTING SOFTWARE.pdf",
    tools: [],
  },

  //web-design
  {
    title: "Web Design (Frontend)",
    duration: "3 Months",
    image: "web-design.webp",
    courseOutline: [
      { id: 1, module: "HTML and CSS" },
      { id: 2, module: "Bootstrap" },
      { id: 3, module: "javascript" },
      { id: 4, module: "Wordpress" },
      { id: 5, module: "ReactJs" },
      { id: 6, module: "Vuejs" },
      { id: 7, module: "Vuetify" },
      { id: 8, module: "NuxtJs" },
      { id: 9, module: "NextJs" },
      { id: 10, module: "CI/CD Tools" },
    ],
    price: 400000,
    showDiscount: false,
    info: {
      title: "Web Designer",
      subTitle: "",
    },
    tools: [],
    curriculumFile: "/curriculum/WEB DESIGN.jpg",
  },

  //backend
  {
    title: "Web Development (Backend)",
    duration: "3 Months",
    image: "webdev.webp",
    courseOutline: [
      { id: 1, module: "PHP" },
      { id: 2, module: "Laravel" },
      { id: 3, module: "JaveScript" },
      { id: 4, module: "NodeJs" },
      { id: 5, module: "Python/Django" },
      { id: 6, module: "Firebase" },
    ],
    price: 400000,
    showDiscount: false,
    info: {
      title: "Web Developer",
      subTitle: "",
    },
    curriculumFile: "/curriculum/Backend Development.pdf",
    tools: [],
  },

  //devops
  {
    title: "DevOps",
    duration: "3 Months",
    image: "devops.webp",
    courseOutline: [
      { id: 1, module: "Version Control with Git" },
      { id: 2, module: "Git, Jenkins and Maven Integration" },
      { id: 3, module: "Continuous Integration using Jenkins" },
      { id: 4, module: "Configuration Management using Ansible" },
      { id: 5, module: "Containerization using Docker Part - I" },
      { id: 6, module: "Containerization using Docker Part - II" },
      { id: 7, module: "Orchestration using Kubernetes Part - I" },
      { id: 8, module: "Orchestration using Kubernetes Part - II" },
      { id: 9, module: "Monitoring using Prometheus and Grafana" },
      { id: 10, module: "Provisioning using Terraform Part - I" },
      { id: 11, module: "Provisioning using Terraform Part - II" },
      { id: 12, module: "Selenium (Self-Paced)" },
      { id: 13, module: "Nagios (Self-Paced)" },
      { id: 14, module: "DevOps on Cloud (Self-Paced)" },
      { id: 15, module: "AWS EC2 and IAM (Self-Paced)" },
    ],
    price: 500000,
    showDiscount: false,
    info: {
      title: "DevOps Engineer",
      subTitle: "",
    },
    tools: [
      "git-bash.svg",
      "jenkins.png",
      "prometheus.png",
      "ansible.png",
      "grafana.webp",
      "docker.png",
      "kubernetes.png",
      "maven.png",
      "terraform.png",
    ],
  },

  //cloud-computing

  {
    title: "Cloud Computing",
    duration: "3 Months",
    image: "cloud-computing.jpeg",
    courseOutline: [],
    price: 1200000,
    showDiscount: false,
    info: {
      title: "Cloud Computing Engineer",
      subTitle: "",
    },
    tools: [],
  },
  //computer-literacy

  {
    title: "Computer litracy",
    duration: "2 Months",
    image: "computer-basics.webp",
    courseOutline: [
      { id: "", module: "Basic Terms" },
      { id: "", module: "Types of Computers" },
      { id: "", module: "Anatomy of a PC" },
      { id: "", module: "How a PC Works" },
      { id: "", module: "CPU and Memory" },
      { id: "", module: "Input Devices" },
      { id: "", module: "Output Devices" },
      { id: "", module: "Secondary Storage Devices" },
      { id: "", module: "Operating Systems and Applications" },
      { id: "", module: "How is Software Built?" },
      { id: "", module: "Types of Software" },
      { id: "", module: "Legal Issues" },
      { id: "", module: "Office Tools" },
    ],
    price: 100000,
    showDiscount: false,
    info: {
      title: "Computer Professional",
      subTitle: "",
    },
    tools: [],
  },

  //video-deitin
  {
    title: "Video Editing & Animation",
    duration: "3 Months",
    image: "video-animation.jpeg",
    courseOutline: [
      { id: "", module: "Getting to know After Effect" },
      { id: "", module: "Tools" },
      { id: "", module: "Work with composition" },
      { id: "", module: "Keyframe animations" },
      { id: "", module: "Create & Animate text" },
      { id: "", module: "Build Custom Transitions " },
      { id: "", module: "Visual Effect" },
      { id: "", module: "Animated Background " },
      { id: "", module: "Build Layers & Compostion " },
      { id: "", module: "Work with  2D & 3D" },
      { id: "", module: "Properties " },
      { id: "", module: "Photoshop & Illlustrator in after effect" },
      { id: "", module: "Repair Video" },
      { id: "", module: "Color Correction " },
      { id: "", module: "Cloning & Green Screen " },
      { id: "", module: "Expression " },
      { id: "", module: "Render" },
    ],
    price: 600000,
    showDiscount: false,
    info: {
      title: "Video Editor",
      subTitle: "",
    },
    tools: [],
  },

  //automation
  {
    title: "Automation: Robotics | IOT",
    duration: "6 Months",
    route: "/iot-automation",
    image: "robotics-and-automation.png",
    courseOutline: [
      { id: "", module: "Computational Geometry" },
      { id: "", module: "Computer-aided Manufacturing" },
      { id: "", module: "Industrial Robotics" },
      { id: "", module: "AI/Machine Learning" },
      { id: "", module: "Automation" },
      { id: "", module: "Biocybernetics" },
      { id: "", module: "Digital Electronics And Microprocessors" },
      { id: "", module: "Design And Control" },
      { id: "", module: "Robot Manipulators" },
      { id: "", module: "Air Traffic And Management Systems" },
      { id: "", module: "Artificial Intelligence" },
      { id: "", module: "Signal Processing" },
      { id: "", module: "Medical Robotics" },
      { id: "", module: "Robot Motion Planning" },
      { id: "", module: "Computer Integrated Manufacturing System " },
    ],
    price: 600000,
    showDiscount: false,
    info: {
      title: "Automation: Robotics | IOT",
      subTitle: "",
    },
    tools: [],
  },

  //advanced-ecel
  {
    title: "Advanced Excel",
    duration: "3 Months",
    image: "excel.png",
    courseOutline: [
      { id: "", module: "Customizing common options in Excel" },
      { id: "", module: "Absolute and relative cells" },
      { id: "", module: "Protecting and unprotecting worksheets and cells" },
      { id: "", module: "Advanced Excel Course - Working with Functions" },
      { id: "", module: "Writing conditional expressions (using IF)" },
      { id: "", module: "Using logical functions (AND, OR, NOT)" },
      {
        id: "",
        module:
          "Using lookup and reference functions (VLOOKUP, HLOOKUP, MATCH, INDEX)",
      },
      { id: "", module: "VlookUP with Exact Match, Approximate Match" },
      { id: "", module: "Nested VlookUP with Exact Match" },
      { id: "", module: "VlookUP with Tables, Dynamic Ranges" },
      { id: "", module: "Nested VlookUP with Exact Match " },
      {
        id: "",
        module: "Using VLookUP to consolidate Data from Multiple Sheets",
      },
      { id: "", module: "Advanced Excel Course - Data Validations" },
      { id: "", module: "Advanced Excel Course - Working with Templates" },
      { id: "", module: "Advanced Excel Course - Sorting and Filtering Data " },
      { id: "", module: "Advanced Excel Course - Working with Reports" },
      { id: "", module: "Creating subtotals" },
      { id: "", module: "Creating Pivot tables" },
      { id: "", module: "Advanced Excel Course - More Functions" },
      { id: "", module: "Text functions" },
      { id: "", module: "Power Functions (CountIf, CountIFS, SumIF, SumIfS) " },
      { id: "", module: "Advanced Excel Course – Formatting" },
      {
        id: "",
        module:
          "Using conditional formatting option for rows, columns and cells ",
      },
      { id: "", module: "Advanced Excel Course – What If Analysis" },
      { id: "", module: "Scenario Manager" },
      { id: "", module: "Advanced Excel Course – Charts" },
      { id: "", module: "Using 3D Graphs" },
      { id: "", module: "Using Bar and Line Chart together " },
      { id: "", module: "Advanced Excel Course - New Features of Excel" },
      {
        id: "",
        module:
          " Spark lines, Inline Charts, data Charts Overview of all the new features",
      },
    ],
    price: 120000,
    showDiscount: false,
    info: {
      title: "Excel software Proffessional",
      subTitle: "",
    },
    tools: [],
  },
  {
    title: "Cyber Security|Ethical Hacking",
    route: "/cyberSecurity",
    duration: "5 Months",
    image: "cyber-security-illustration-free-vector.jpeg",
    courseOutline: [
      { id: "1", module: "Fundamentals of Cybersecurity" },
      { id: "1", module: "Network Security" },
      { id: "1", module: "Database Security	" },
      { id: "1", module: "Server Security" },
      { id: "1", module: "Web Application Security	" },
      { id: "1", module: "IT Security Compliance" },
      { id: "1", module: "Android Penetration Testing	" },
      { id: "1", module: "Computer Forensics" },
      { id: "1", module: "Python Programming	" },
      { id: "1", module: "Project work" },
    ],
    price: 500000,
    showDiscount: false,
    info: {
      title: "Ethical Hacker",
      subTitle: "",
    },
    tools: [],
    curriculumFile: "/curriculum/Cyber Security.jpg",
  },
  {
    title: "Matlab",
    duration: "3 Months",
    image: "matlab.jpg",
    courseOutline: [
      { id: "", module: "Desktop,Variables, and Data Types" },
      { id: "", module: "Introduction to MATLAB" },
      { id: "", module: "Creating Variables Some Useful MATLAB Functions" },
      { id: "", module: "Data Types" },
      { id: "", module: "Script Files " },
      { id: "", module: "Plotting Videos" },
      { id: "", module: "Introduction to Arrays Graphing Exercises" },
      { id: "", module: "Graphing Functions Using MATLAB" },
      { id: "", module: "Good Programming Practices" },
      { id: "", module: "Planning Your Code Good Programming Practices" },
      { id: "", module: "Creating Your Code" },
      { id: "", module: "Input and Output Statements" },
      { id: "", module: "Conditional Statements:Logical Operators" },
      { id: "", module: "Conditional Statements: if, else, and elseif" },
      { id: "", module: "Conditional Structures: Switch" },
      { id: "", module: "Introduction to Loops Repetition Structure" },
      { id: "", module: "For Loops Repetition Structure" },
      { id: "", module: "While Loops" },
      { id: "", module: "Nested Loops and the Break Statement" },
      { id: "", module: "Arrays" },
      { id: "", module: "Array Functions " },
      { id: "", module: "Useful Functions for Arrays" },
    ],
    price: 60000,
    showDiscount: false,
    info: {
      title: "Matlab Developer",
      subTitle: "",
    },
    tools: [],
  },
  {
    title: "Graphics Design",
    duration: "2 Months",
    image: "Graphic-Design.png",
    courseOutline: [],
    price: 360000,
    showDiscount: false,
    info: {
      title: "Graphics Designer",
      subTitle: "",
    },
    tools: [],
  },
  {
    title: "Data Analytics",
    duration: "3 Months",
    image: "dat- science.jpeg",
    courseOutline: [],
    price: 300000,
    showDiscount: false,
    info: {
      title: "Graphics Designer",
      subTitle: "",
    },
    tools: [],
  },
  {
    title: "Product Management",
    duration: "3 Months",
    image: "product-manager.webp",
    courseOutline: [],
    price: 480000,
    showDiscount: false,
    info: {
      title: "Product Manager",
      subTitle: "",
    },
    tools: [],
    curriculumFile: "/curriculum/Product Management.jpg",
  },
  {
    title: "Software Engineering",
    duration: "10 Months",
    image: "engineer.avif",
    courseOutline: [],
    price: 960000,
    showDiscount: false,
    info: {
      title: "Software Designer",
      subTitle: "",
    },
    tools: [],
  },

  {
    title: "Mobile App Development",
    duration: "6 Months",
    image: "software-Engineering.jpeg",
    courseOutline: [
      {
        id: "1",
        module: "Overview of Mobile Development (Native vs. Cross-Platform)",
      },
      { id: "1", module: "Introduction to React Native Ecosystem" },
      {
        id: "1",
        module: "Development Environment Setup (Node.js, npm/yarn, Expo CLI)",
      },
      {
        id: "1",
        module: "JavaScript Basics (Variables, Functions, Loops, Conditionals)",
      },
      {
        id: "1",
        module:
          "ES6+ Features (Arrow Functions, Template Literals, Destructuring, Spread/Rest Operators)",
      },
      { id: "1", module: "Asynchronous Programming (Promises, Async/Await)" },
      { id: "1", module: "React Hooks (useState, useEffect)" },
      { id: "1", module: "Error Handling & Debugging" },
      { id: "1", module: "React Navigation (Stack, Tab, Drawer Navigation)" },
      {
        id: "1",
        module: "Passing Data Between Screens (Props, Route Params)",
      },
      {
        id: "1",
        module:
          "TypeScript Integration (Classes, Interfaces, Typing Components, Props, State)",
      },
      { id: "1", module: "React Native Animations (Animated API, Reanimated)" },
      {
        id: "1",
        module:
          "Testing (Jest, React Native Testing Library, Unit, Integration, Snapshot Testing)",
      },
      {
        id: "1",
        module: "Debugging Tools (Reactotron, Flipper, Console Logging)",
      },
      {
        id: "1",
        module:
          "Performance Optimization (FlatList Optimization, Code Splitting, Lazy Loading, Bundle Size Reduction)",
      },
      {
        id: "1",
        module:
          "Deployment Preparation (APK/IPA generation, App Icons, Splash Screens, Permissions)",
      },
      { id: "1", module: "Store Submission (Google Play, Apple App Store)x  " },
      { id: "1", module: "Over-the-Air Updates (Expo)" },
      { id: "1", module: "Architecture of Apple devices" },
      {
        id: "1",
        module:
          "Capstone Project (Supabase Backend, Firebase Authentication & Notifications, API Integration, State Management, Animations, Native Features)",
      },
      { id: "1", module: "Testing & Optimization for Production" },
      { id: "1", module: "Understanding basics of Objective – C" },
      { id: "1", module: "App development using Objective – C" },
    ],
    price: 360000,
    showDiscount: false,
    info: {
      title: "Mobile App Developer",
      subTitle: "",
    },
    tools: [],
    curriculumFile: "/curriculum/mobile-development.pdf",
  },

  {
    title: "Human Resource Management",
    duration: "3 Months",
    image: "software-Engineering.jpeg",
    courseOutline: [
      { id: "1", module: "Introduction to Human Resource Management" },
      { id: "1", module: "Role and scope of HRM" },
      {
        id: "1",
        module: "HR as a strategic partner in organizations",
      },
      {
        id: "1",
        module: "Key trends in modern HR practices",
      },
      {
        id: "1",
        module: "Recruitment, Selection & Onboarding",
      },
      { id: "1", module: "Workforce planning" },
      { id: "1", module: "Job descriptions and person specifications" },
      { id: "1", module: "Interview techniques and onboarding strategies" },
      { id: "1", module: "Performance & Employee Development" },
      {
        id: "1",
        module: "Setting KPIs and performance appraisal systems",
      },
      { id: "1", module: "Training and development planning" },
      { id: "1", module: "Employee engagement and retention strategies" },
      { id: "1", module: "Labor laws and HR compliance" },
      { id: "1", module: "Workplace ethics and grievance handling" },
      { id: "1", module: "Creating inclusive and safe workplaces" },
    ],
    price: 240000,
    showDiscount: false,
    info: {
      title: "Human Resource Management",
      subTitle: "",
    },
    tools: [],
  },

  {
    title: "BlockChain Development",
    duration: "3 Months",
    image: "Blockchain.png",
    courseOutline: [
      { id: "1", module: "Blockchain Fundamentals" },
      { id: "1", module: "Blockchain Basics" },
      { id: "1", module: "Managing Blockchain Transactions" },
      { id: "1", module: "Bitcoin core Testnet" },
      { id: "1", module: "Blockchain Data" },
      { id: "1", module: "Private Blockchains" },
      { id: "1", module: "Digital Assets on Blockchain" },
      { id: "1", module: "Ethereum Smart Contracts, Tokens and Dapps" },
      { id: "1", module: "Ethereum Fundamentals and Development Tools" },
      { id: "1", module: "Smart Contracts with Solidity" },
      { id: "1", module: "Ethereum APP" },
      { id: "1", module: "Blockchain Architecture" },
      { id: "1", module: "Planning Blockchain Solutions" },
      { id: "1", module: "Privacy" },
      { id: "1", module: "Security & Maintenance" },
      { id: "1", module: "Distributed file system" },
      {
        id: "1",
        module: "Dapp with autonomous smart contracts and oracles",
      },
      {
        id: "1",
        module: "Multiparty control and payments with smart contracts",
      },
      { id: "1", module: "ORACLES" },
      { id: "1", module: "Handing smart contract payments" },
    ],
    price: 1440000,
    showDiscount: false,
    info: {
      title: "Blockchain Developer",
      subTitle: "",
    },
    tools: [],
  },
];

const slugifyCourseTitle = (title) =>
  title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const allCoursesWithSlugs = allCourses.map((course) => ({
  ...course,
  slug: course.slug || slugifyCourseTitle(course.title),
}));

export default allCoursesWithSlugs;
